(function () {
    "use strict";

    function initProgramTabs() {
        var tabs = document.querySelectorAll(".ev-program__tab");
        var days = document.querySelectorAll(".ev-program__day");
        var isAnimating = false;

        if (!tabs.length) return;

        function getActiveIndex() {
            for (var i = 0; i < tabs.length; i++) {
                if (tabs[i].classList.contains("is-active")) return i;
            }
            return 0;
        }

        tabs.forEach(function (tab, newIndex) {
            tab.addEventListener("click", function () {
                if (isAnimating) return;

                var currentIndex = getActiveIndex();
                if (newIndex === currentIndex) return;

                var goingForward = newIndex > currentIndex;
                var exitClass    = goingForward ? "ev-slide-out-left"  : "ev-slide-out-right";
                var enterClass   = goingForward ? "ev-slide-in-right"  : "ev-slide-in-left";

                isAnimating = true;

                var currentDate = tabs[currentIndex].getAttribute("data-date");
                var nextDate    = tab.getAttribute("data-date");
                var currentDay  = null;
                var nextDay     = null;

                days.forEach(function (day) {
                    if (day.getAttribute("data-date") === currentDate) currentDay = day;
                    if (day.getAttribute("data-date") === nextDate)    nextDay    = day;
                });

                // Update tab active state immediately
                tabs.forEach(function (t) {
                    t.classList.remove("is-active");
                    t.setAttribute("aria-selected", "false");
                });
                tab.classList.add("is-active");
                tab.setAttribute("aria-selected", "true");

                if (!currentDay || !nextDay) {
                    isAnimating = false;
                    return;
                }

                // Slide out current day
                currentDay.classList.add(exitClass);

                setTimeout(function () {
                    currentDay.classList.remove(exitClass);
                    currentDay.setAttribute("hidden", "");

                    nextDay.removeAttribute("hidden");
                    nextDay.classList.add(enterClass);

                    nextDay.addEventListener("animationend", function cleanup() {
                        nextDay.classList.remove(enterClass);
                        nextDay.removeEventListener("animationend", cleanup);
                        isAnimating = false;
                    });
                }, 200);
            });
        });
    }

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initProgramTabs);
    } else {
        initProgramTabs();
    }
})();
